// © 2015-2021 WDNA - All Rights Reserved

import * as React from 'react';

import { TabLoader, TabConfig, addTab, removeAll } from 'wdna-components/lib/tabs';

const Component: React.LazyExoticComponent<any> = React.lazy(() => import('../containers/EmptyPage'));

export default class EmptyPage extends TabLoader {
  /* Override tab loader method */
  public loadTab = (tabId?: string | number): void => {
    window.store.dispatch(removeAll());

    const tabData: TabConfig = {
      id: String(tabId || window.getStr()),
      active: true,
      title: 'Empty page',
      component: Component,
      props: {
        title: 'Empty page',
      },
    };

    window.store.dispatch(addTab(tabData));
  };
}
